const axiosInstanceWeb = require("./axiosInstanceWeb");

const register = async (dataReq) => {
    try {
        const response = await axiosInstanceWeb.post("/dinhpv", dataReq);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const SeminarService = {
    register,
};

module.exports = SeminarService;
